<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#ubn">
            <i class="material-symbols-rounded text-lg me-2">location_on</i>
            <span class="text-sm">{{ $t('death.Death_from_UBN') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#animal">
            <i class="material-symbols-rounded text-lg me-2">pets</i>
            <span class="text-sm">{{ $t('death.Animal') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#date">
            <i class="material-symbols-rounded text-lg me-2">overview</i>
            <span class="text-sm">{{ $t('death.Date_of_death') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#destructor">
            <i class="material-symbols-rounded text-lg me-2">location_on</i>
            <span class="text-sm">{{ $t('death.Destructor') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('common.Delete') }}</span>
          </a>
        </li>        
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditDeathSideNav",
  };
  </script>
  